import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { ApiCommonParams } from "../../../../api/@types/apiTypes";
import { showApiErrorMessages } from "../../../../helpers";
import Pagination from "../../../../components/pagination/Pagination";
import PlaceHolder from "../../../../components/placeHolder.tsx/PlaceHolder";
import { indexSessions } from "../../../../api/endpoints/supervisors/sessions";
import SessionModel from "../../../../api/models/SessionModel";
import { SessionsTable } from "./SessionsTable";
import { useLocation, useSearchParams } from "react-router-dom";
import useParamState from "../../../../hooks/useParamState";
import useMultiValueParam from "../../../../hooks/useMultiValueParam";

type SupervisorSessionsViewProps = {
  page: number;
};

export default function SupervisorSessionsView(
  props: SupervisorSessionsViewProps
) {
  const { page } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState(page);
  const [studentFilter, setStudentFilter] = useMultiValueParam(
    "student_id",
    []
  );
  const [tutorFilter, setTutorFilter] = useMultiValueParam("tutor_id", []);
  const [statusFilter, setStatusFilter] = useParamState<string>("status", "");
  const location = useLocation();
  const pathname = location.pathname;

  const { data: sessions, refetch } = useQuery(
    ["prevSessions", currentPage],
    () => {
      const studentFilterObj = createOptionTypeObject(studentFilter, "student");
      const tutorFilterObj = createOptionTypeObject(tutorFilter, "tutor");

      let filters: any = {
        order_by: "-created_at",
        ...studentFilterObj,
        ...tutorFilterObj,
      };

      if (statusFilter) {
        filters = { ...filters, status: statusFilter };
      }

      let apiParams: ApiCommonParams = {
        pagination: { pageSize: 10, pageNumber: currentPage },
        filters,
      };

      return indexSessions(apiParams);
    },
    {
      keepPreviousData: true,
      select: (response) => {
        let fetchedStudents: SessionModel[] = [];
        if (response.isSuccess) {
          fetchedStudents = SessionModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        const paginationInfo = response.pagination;
        return { data: fetchedStudents, paginationInfo };
      },
    }
  );

  useEffect(() => {
    refetch();
  }, [studentFilter, tutorFilter, statusFilter]);

  useEffect(() => {
    searchParams.set("tab", "1");
    window.history.replaceState(
      null,
      "",
      `${pathname}?${searchParams.toString()}`
    );
  }, []);

  useEffect(() => {
    searchParams.set("page", String(currentPage));

    window.history.replaceState(
      null,
      "",
      `${pathname}?${searchParams.toString()}`
    );
  }, [currentPage]);

  function createOptionTypeObject(
    ids: number[],
    optionType: string
  ): { [key: string]: number[] } {
    // Validate inputs to ensure they meet expected criteria
    if (!Array.isArray(ids) || typeof optionType !== "string") {
      throw new Error(
        "Invalid arguments: 'ids' must be an array and 'optionType' must be a string."
      );
    }

    // Return the constructed object
    return {
      [`${optionType}_id`]: ids,
    };
  }

  return (
    <div className="w-full  mt-3 md:mt-0  min-h-screen  flex flex-col justify-between bg-white">
      <div
        className={`flex flex-col h-full min-w-full w-fit ${
          !!sessions?.data && sessions.data.length > 0 && " ring-gray-300"
        }`}
      >
        <SessionsTable
          page={currentPage}
          refetch={refetch}
          sessions={sessions?.data ?? []}
          setStatusFilter={setStatusFilter}
          setStudentFilter={setStudentFilter}
          setTutorFilter={setTutorFilter}
          statusFilter={statusFilter}
          studentFilter={studentFilter}
          tutorFilter={tutorFilter}
        />
        {!!sessions?.data && sessions.data.length > 0 ? (
          <>
            <div className="sticky bottom-0 mt-10 ">
              <Pagination
                hasNext={!!sessions.paginationInfo?.hasNext}
                hasPrev={!!sessions.paginationInfo?.hasPrev}
                goToPage={(page: number) => setCurrentPage(page)}
                currentPage={sessions.paginationInfo?.currentPageNumber!}
                numberOfPages={sessions.paginationInfo?.pagesCount!}
              />
            </div>
          </>
        ) : (
          <div className="w-full h-full flex justify-center items-center">
            <PlaceHolder title="noReadersTitle" />
          </div>
        )}
      </div>
    </div>
  );
}
